/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerlinksadd2Inputs */

const en_organizerlinksadd2 = /** @type {(inputs: Organizerlinksadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add links`)
};

const de_organizerlinksadd2 = /** @type {(inputs: Organizerlinksadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links eintragen`)
};

/**
* | output |
* | --- |
* | "Add links" |
*
* @param {Organizerlinksadd2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerlinksadd2 = /** @type {((inputs?: Organizerlinksadd2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerlinksadd2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerlinksadd2(inputs)
	return de_organizerlinksadd2(inputs)
});
export { organizerlinksadd2 as "organizerLinksAdd" }